import { SelectSymbolPrice } from 'components/form/compobox/select-symbolprice'
export default function Symbol({brand,index}) {
  return (
    <div className="space-y-2 border border-dashed p-2 rounded">
      <SelectSymbolPrice washType="wash" brand={brand} index={index} />
      <SelectSymbolPrice washType="bleach" brand={brand} index={index} />
      <SelectSymbolPrice washType="tumble" brand={brand} index={index} />
      <SelectSymbolPrice washType="iron" brand={brand} index={index} />
      <SelectSymbolPrice washType="dry" brand={brand} index={index} />
    </div>
  )
}
